<mde-popover
  #detailPopover="mdePopover"
  [mdePopoverOverlapTrigger]="false"
  mdePopoverArrowColor="#FFFFFF"
  [mdePopoverCloseOnClick]="false"
  mdePopoverOffsetX="-19"
  mdePopoverOffsetY="-1"
>
  <vex-general-tooltip [label]="label" [value]="value"></vex-general-tooltip>
</mde-popover>
<div class="card relative hover:shadow-16 trans-shadow">
  <div class="rounded p-2 myStyle">
    <div class="border-b mb-2">
      <div fxLayout="row" class="mb-2" fxLayoutAlign="space-between center">
        <div fxLayout="row">
          <img
            class="w-20 h-20 avatar"
            [src]="device.ManufacturerImage"
            alt="User Picture"
            onError="this.src='assets/default/Custom/no-image-available.svg'"
          />
          <div fxLayout="column" class="pl-2">
            <div fxLayout="row" (mouseenter)="showTooltip(device.name || device.Name, 'Name')">
              <p
                (click)="openDeviceDetails()"
                class="font-medium cursor-pointer hover:text-primary trans-ease-out"
                [mdePopoverTriggerFor]="detailPopover"
                #target="mdePopoverTrigger"
                mdePopoverTriggerOn="hover"
                matRipple
              >
                {{ device.Name }}
                <button color="primary" type="button">
                  <ic-icon
                    [icon]="icExternalLink"
                    class="mx-1"
                    inline="true"
                    size="15px"
                  ></ic-icon>
                </button>
              </p>
            </div>
            <div
              class="text-secondary font-medium text-xs"
              fxLayout="row"
              fxLayoutAlign="start center"
            >
              <p>{{ device.DeviceType || 'N/A' }}</p>
            </div>
            <div fxLayout="row">
              <div class="label bg-purple-light text-purple" fxFlex="none">
                <b>v {{ device.Version }}</b>
              </div>
              <div *ngIf="showsConnectionDetails" class="label ml-1" fxFlex="none" [ngClass]="state?.LblClass">
                {{ state?.Value }}
              </div>
              <div
                *ngIf="managesConfiguration"
                class="label ml-1 "
                style="display: inherit"
                fxFlex="none"
                [ngClass]="inventoryState?.LblClass"
              >
                {{ inventoryState?.Value }}
              </div>
            </div>
          </div>
        </div>
        <ng-content select="[rightHeaderContent]"></ng-content>
      </div>
    </div>
    <div fxLayout="row">
      <div class="image-div">
        <ng-container *ngIf="!device.bindDefaultImage; else manufactureIcon">
          <img
            [src]="device.Image"
            (error)="device.bindDefaultImage = true"
            lightbox
          />
        </ng-container>
        <ng-template #manufactureIcon>
          <img
            [src]="device.DeviceImage"
            onError="this.src='assets/default/Custom/no-image-available.svg'"
            lightbox
          />
        </ng-template>
      </div>
      <div fxLayout="column" class="w-full ml-4">
        <div class="mb-4" fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="16px">
          <div fxFlex>
            <p class="primary leading-normal">Location :</p>
            <ng-container *ngIf="device.DataCenterSite && device.DataCenterSite !== 'N/A'; else noLocation">
            <a (mouseenter)="showTooltip(device.DataCenterSite, 'Location')"
              target="_blank"
              [href]="'/location/list?id=' + device.DataCenterSiteId">
              <p
                class="font-medium header-text text-primary avi-link"
                [mdePopoverTriggerFor]="detailPopover"
                #target="mdePopoverTrigger"
                mdePopoverTriggerOn="hover"
              >
                {{ device.DataCenterSite }}
                <button color="primary" type="button">
                  <ic-icon
                    [icon]="icExternalLink"
                    class="mx-1"
                    inline="true"
                    size="15px"
                  ></ic-icon>
                </button>
              </p>
            </a>
            </ng-container>
            <ng-template #noLocation>
              <p
                class="font-medium header-text">
                N/A
              </p>
            </ng-template>
          </div>
          <div fxFlex>
            <p class="primary leading-normal">IP Address :</p>
            <p (mouseenter)="showTooltip(device.IpAddress, 'IP Address')"
              class="font-medium header-text"
              [mdePopoverTriggerFor]="detailPopover"
              #target="mdePopoverTrigger"
              mdePopoverTriggerOn="hover"
            >
              {{ device.IpAddress || 'N/A' }}
            </p>
          </div>
          <div fxFlex>
            <p class="primary leading-normal">Created :</p>
            <p
              class="font-medium header-text"
            >
              {{ device.createBy }}
              {{ device.createDate | dateFormat }}
            </p>
          </div>
        </div>
        <div class="mb-4" fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="16px">
          <div fxFlex>
            <p class="primary leading-normal">Provider :</p>
            <p
              class="font-medium header-text"
              [mdePopoverTriggerFor]="detailPopover"
              #target="mdePopoverTrigger"
              mdePopoverTriggerOn="hover"
            >
              {{ device.provider || 'N/A' }}
            </p>
          </div>
          <div *ngIf="managesConfiguration" fxFlex>
            <p class="primary leading-normal">Auth Profile :</p>
            <ng-container *ngIf="device.DeviceAuthentication && device.DeviceAuthentication !== 'N/A'; else noDeviceAuthentication">
            <a target="_blank" (mouseenter)="showTooltip(device.DeviceAuthentication, 'Auth Profile')"
              [href]="'/application-settings/device-authentication?id=' + device.DeviceAuthenticationId">
              <p
                class="font-medium header-text text-primary avi-link"
                [mdePopoverTriggerFor]="detailPopover"
                #target="mdePopoverTrigger"
                mdePopoverTriggerOn="hover"
              >
                {{ device.DeviceAuthentication }}
                <button color="primary" type="button">
                  <ic-icon
                    [icon]="icExternalLink"
                    class="mx-1"
                    inline="true"
                    size="15px"
                  ></ic-icon>
                </button>
              </p>
            </a>
            </ng-container>
            <ng-template #noDeviceAuthentication>
              <p
                class="font-medium header-text">
                N/A
              </p>
            </ng-template>
          </div>
          <div fxFlex>
            <p class="primary leading-normal">Changed :</p>
            <p
              class="font-medium header-text"
            >
              {{ device.updateBy }}
              {{ device.updateDate | dateFormat }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <ng-content select="[bottomContent]"></ng-content>
  </div>
</div>
